import React, { useState, useCallback } from 'react';
import { Button, Card, FileUpload, ErrorAlert } from '../../../components/shared';
import { cn } from '../../../utils/cn';
import FaceCapture from './FaceCapture';
import VideoCapture from './VideoCapture';

const MODES = [
  { value: 'photo', label: 'Chụp ảnh' },
  { value: 'record', label: 'Quay video' },
  { value: 'upload', label: 'Tải lên' },
];

export default function LivenessStep({ onSubmit, onSkip, loading, error }) {
  const [mode, setMode] = useState('photo');
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);

  const handleFile = useCallback((f) => {
    setFile(f);
    setFileName(f.name);
  }, []);

  const handleReset = useCallback(() => {
    setFile(null);
    setFileName(null);
  }, []);

  if (mode === 'photo' && !file) {
    return (
      <FaceCapture
        onCapture={handleFile}
        onCancel={() => setMode('upload')}
      />
    );
  }

  if (mode === 'record' && !file) {
    return (
      <VideoCapture
        onCapture={handleFile}
        onCancel={() => setMode('upload')}
      />
    );
  }

  return (
    <Card title="Xác thực khuôn mặt" description="Chụp ảnh selfie rõ ràng, nhìn thẳng vào camera">
      <ErrorAlert error={error} className="mb-4" />

      <div className="mb-4 flex rounded-lg bg-gray-100 p-1">
        {MODES.map((m) => (
          <button
            key={m.value}
            type="button"
            onClick={() => { handleReset(); setMode(m.value); }}
            className={cn(
              'flex-1 rounded-md px-3 py-2 text-sm font-medium transition-colors',
              mode === m.value
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            )}
          >
            {m.label}
          </button>
        ))}
      </div>

      <div className="mx-auto max-w-sm">
        {!file && mode === 'upload' && (
          <FileUpload
            label="Ảnh selfie hoặc video"
            accept="image/jpeg,image/png,video/mp4,video/webm,video/quicktime"
            onChange={handleFile}
            disabled={loading}
          />
        )}

        {file && (
          <div className="flex flex-col items-center gap-3">
            {file.type.startsWith('image/') ? (
              <div className="overflow-hidden rounded-lg">
                <img
                  src={URL.createObjectURL(file)}
                  alt="Preview"
                  className="h-48 w-48 rounded-lg object-cover"
                />
              </div>
            ) : (
              <div className="flex items-center gap-2 rounded-lg bg-green-50 px-4 py-3">
                <svg className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div>
                  <p className="text-sm font-medium text-green-700">{fileName}</p>
                  <p className="text-xs text-green-500">{(file.size / 1024 / 1024).toFixed(1)} MB</p>
                </div>
              </div>
            )}
            <button
              type="button"
              onClick={handleReset}
              className="text-sm text-blue-600 hover:text-blue-800"
            >
              {mode === 'photo' ? 'Chụp lại' : mode === 'record' ? 'Quay lại' : 'Chọn file khác'}
            </button>
          </div>
        )}
      </div>

      <div className="mt-6 flex justify-between">
        {onSkip && (
          <Button variant="ghost" onClick={onSkip} disabled={loading}>
            Bỏ qua
          </Button>
        )}
        <div className="ml-auto">
          <Button onClick={() => onSubmit(file)} loading={loading} disabled={!file}>
            Tiếp tục
          </Button>
        </div>
      </div>
    </Card>
  );
}
